<template>
  <div class="app-main-content" type="primary">
    <div
      v-show="showMainList"
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          config-module="701"
          :reset="true"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="toView"
            >查看
            </el-button>
            <el-button
              type="primary"
              @click="toAdd"
            >新增
            </el-button>
            <el-button
              type="primary"
              @click="toEdit"
            >编辑
            </el-button>
            <el-button
              type="danger"
              @click="handleDelOrder"
            >删除
            </el-button>
            <el-button
              type="danger"
              @click="batchHandleDelOrder"
            >{{ $t('CargoMsg.Cargo_BatchDelete') }}
            </el-button>
            <el-button
              type="primary"
              @click="onBatchPrint"
            >打印
            </el-button>
            <el-button
              type="primary"
              @click="handleShowReportTemplateSelect"
            >导出库存报告
            </el-button>
            <el-button
              type="primary"
              @click="handleExportWarehouseInPackageDetail"
            >导出入仓箱单
            </el-button>
            <el-button
              type="primary"
              @click="handleBatchIncomeWarehouseIn"
            >{{ $t('Warehouse.BatchImportWarehousing') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="701001"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="701001"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <warehousing-detail
      v-if="showDetail"
      ref="warehousingDetail"
      @backList="toBackPreView"
    />
    <template-select-dialog
      :visible="templateSelectVisible"
      :filter-json="filterJson"
      :options="templateObj"
      @onSubmit="handleExportExcel"
      @onClose="templateSelectVisible=false"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <import-dialog
      :title="$t('Warehouse.BatchImportWarehousingData')"
      :action="`${URL.warehouseIn.batchIncomeList}`"
      :visible="packageImportVisible"
      :is-async="true"
      @onClose="packageImportVisible = false"
      @handleExport="exportTemplate"
    />
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import warehousingDetail from './components/Warehousing/warehousingDetail'
import {
  queryWarehouseInPageable,
  deleteWarehouseIn,
  exportInventoryReport,
  queryVehicleType,
  exportWarehouseInPackageDetail,
  batchDeleteWarehouseIn,
  exportBatchNeedWarehouseInPackage
} from '@/api/OMS/warehouseIn'
import convertResToBlob from '@/utils/convertResToBlob'
import TemplateSelectDialog from '@/components/Cargo/Common/templateSelectDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ImportDialog from '@/views/cargo/v0/OMS/components/Warehousing/importDialog'
import URL from '@/api/urlTranslator'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'

export default {
  name: 'Warehousing',
  components: {
    ImportDialog,

    searchItem,
    warehousingDetail,
    TemplateSelectDialog,
    cargoTemplateSelectorDialog
  },
  data() {
    return {
      URL,
      isAdvancedQuery: false, // 是否为高级查询
      packageImportVisible: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.toView
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'WAREHOUSE',
        data: {
          WAREHOUSE_UUID: []
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '进仓编号',
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 150
        },
        {
          headerName: '通知客户',
          colId: 'notifierName',
          field: 'notifierName',
          width: 150
        },
        {
          headerName: '仓库供应商',
          colId: 'supplierName',
          field: 'supplierName',
          width: 150
        },
        {
          headerName: '仓库名',
          colId: 'warehouse',
          field: 'warehouse',
          width: 150
        },
        {
          headerName: '最早进仓时间',
          colId: 'warehouseInDateFrom',
          field: 'warehouseInDateFrom',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '最晚进仓时间',
          colId: 'warehouseInDateTo',
          field: 'warehouseInDateTo',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '回执单号',
          colId: 'receiptNo',
          field: 'receiptNo',
          width: 150
        },
        {
          headerName: '送货公司',
          colId: 'deliveryCmp',
          field: 'deliveryCmp',
          width: 150
        },
        {
          headerName: '实际进仓时间',
          colId: 'warehouseInDate',
          field: 'warehouseInDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '进仓状态',
          colId: 'state',
          field: 'state',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_IN_STATE,
              'code',
              params.value,
              'chineseName'
            )
          }
        },
        {
          headerName: '备注',
          colId: 'remarks',
          field: 'remarks',
          width: 150
        },
        {
          headerName: '创建人',
          colId: 'createUserName',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '接收时间',
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '更新人',
          colId: 'modifyUserName',
          field: 'modifyUserName',
          width: 150
        },
        {
          headerName: '更新时间',
          colId: 'dateModified',
          field: 'dateModified',
          width: 150
        },
        {
          headerName: '司机',
          colId: 'driver',
          field: 'driver',
          width: 150
        },
        {
          headerName: '车牌',
          colId: 'truckNo',
          field: 'truckNo',
          width: 150
        },
        {
          headerName: '司机联系电话',
          colId: 'driverTel',
          field: 'driverTel',
          width: 150
        },
        {
          headerName: '车辆类型',
          colId: 'vehicleType',
          field: 'vehicleType',
          width: 150,
          valueFormatter: (params) => {
            return this.vehicleType[params.value]
          }
        }
      ],
      rowData: [],
      templateSelectVisible: false,
      templateObj: [
        {
          key: 'CBCC',
          name: '库存报告'
        }
      ],
      vehicleType: {}
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  async created() {
    const { data } = await queryVehicleType()
    data.forEach((item) => {
      this.vehicleType[item.code] = item.name
    })
  },
  beforeMount() {
    this.toQuery()
  },
  methods: {
    fetchWarehousingRequirement() {
      this.fullscreenLoading = getLoading()
      queryWarehouseInPageable(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.warehouseNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryWarehouseInPageable(this.filter).then((res) =>
        this.handleQueryData(res)
      )
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      queryWarehouseInPageable(this.filterJson).then((res) =>
        this.handleQueryData(res)
      )
    },
    // 返回
    toBackPreView(toView) {
      this.showDetail = false
      this.fetchWarehousingRequirement()
    },
    showDetailDialog(uuid, oprationType, curSelected) {
      this.$nextTick(() => {
        console.log('showdetail', oprationType, this.$refs.warehousingDetail)
        this.$refs.warehousingDetail.showDetail(uuid, oprationType, curSelected)
      })
    },
    toView(event) {
      const curSelected = event.data
      const { api } = this.gridOptions
      let selectedRows = api.getSelectedRows()
      if (!selectedRows) selectedRows = []
      let exit = false
      if (selectedRows.length > 0 && curSelected) {
        for (const selectedRow of selectedRows) {
          if (curSelected.uuid === selectedRow.uuid) {
            exit = true
            break
          }
        }
      }
      if (!exit && curSelected) selectedRows.splice(0, 0, curSelected)
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要查看的订单')
        return
      }
      const uuid = selectedRows.map((item) => {
        return {
          uuid: item.uuid,
          warehouseNo: item.warehouseNo
        }
      })
      this.showDetail = true
      this.showDetailDialog(uuid, 1, curSelected)
    },
    toAdd() {
      this.showDetail = true
      this.showDetailDialog(undefined, 2)
    },
    toEdit() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要编辑的进仓单')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error('一次只能编辑一条进仓单')
        return
      }
      this.showDetail = true
      console.log(selectedRows[0])
      this.showDetailDialog(selectedRows[0].uuid, 3)
    },
    handleDelOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要删除的进仓通知单')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error('一次只能删除一条进仓通知单')
        return
      }
      const item = selectedRows[0]
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '进仓通知单:'),
          h('span', { style: 'margin: 0 10px' }, item.warehouseNo)
        ]),
        h('p', { style: 'color: red' }, '是否确定删除此进仓通知单?')
      ])
      this.$confirm(content, '删除进仓通知单', {
        type: 'warning'
      }).then(() => {
        deleteWarehouseIn({ warehouseInUuid: item.uuid }).then((res) => {
          this.$message.success('删除成功')
          this.fetchWarehousingRequirement()
        })
      })
    },
    batchHandleDelOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('Warehouse.PleaseSelectTheWarehousingNoticeToBeDeleted'))
        return
      }
      const warehouseNos = []
      const warehouseKeys = []
      for (const item of selectedRows) {
        warehouseNos.push(item.warehouseNo)
        warehouseKeys.push(item.uuid)
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('Warehouse.WarehousingNotice') + ':'),
          h('span', { style: 'margin: 0 10px;display:inline-block;width:80%;word-wrap:break-word;white-space:normal;' }, warehouseNos.join(','))
        ]),
        h('p', { style: 'color: red' }, this.$t('Warehouse.AreYouSureToDeleteThisWarehousingNotice'))
      ])
      this.$confirm(content, this.$t('Warehouse.DeleteWarehousingNotice'), {
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        batchDeleteWarehouseIn(warehouseKeys).then((res) => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.fetchWarehousingRequirement()
        })
      })
    },

    handleShowReportTemplateSelect() {
      this.templateSelectVisible = true
    },
    handleExportExcel(e) {
      switch (e) {
        case 'CBCC':
          this.handleExportInventoryReport()
          break
      }
    },
    handleExportInventoryReport() {
      const params = {
        ...this.filterJson,
        templateName: 'CBCC'
      }
      this.fullscreenLoading = getLoading()
      exportInventoryReport(params)
        .then((res) => {
          this.fullscreenLoading.close()
          this.templateSelectVisible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    /**
     * 打印
     */
    onBatchPrint() {
      const selectedPoItems = this.gridOptions.api.getSelectedRows()
      if (selectedPoItems.length === 0) {
        this.$message.warning('未选择进仓单')
        return
      }
      const uids = []
      for (const j of selectedPoItems) {
        uids.push(j.uuid)
      }
      if (uids.length > 0) {
        this.templateSelectorDialog.visible = true
        this.templateSelectorDialog.data = { WAREHOUSE_UUID: uids, 'printSource': DocumentConstants.BATCH_PRINT_JCGL.code }
      }
    },
    handleExportWarehouseInPackageDetail() {
      console.log(this.gridOptions.api)
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning('未选择进仓单')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.warning('一次只能导出一个入仓箱单')
        return
      }
      this.fullscreenLoading = getLoading()
      const params = { warehouseInUuid: selectedRows[0].uuid, templateName: 'CBCC' }
      exportWarehouseInPackageDetail(params).then(res => {
        convertResToBlob(res)
        this.$message.success('请求成功，正在导出！')
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleBatchIncomeWarehouseIn() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Warehouse.NoWarehouseReceiptSelected'))
        return
      }
      this.packageImportVisible = true
    },
    exportTemplate() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const warehouseInKeys = []
      for (const selectedRow of selectedRows) {
        warehouseInKeys.push(selectedRow.uuid)
      }
      exportBatchNeedWarehouseInPackage(warehouseInKeys).then((res) => {
        convertResToBlob(res)
      })
    }
  }
}
</script>
